export enum NoticePublishType {
  Now = "now",
  Scheduled = "scheduled"
}
